{
    "page": {
        "key": "page",
        "position": {
            "x": 5,
            "y": 5,
            "z": 1
        }
    },
    "HGRl4": {
        "key": "HGRl4",
        "position": {
            "x": 7,
            "y": 4,
            "z": 1
        },
        "tag": "tree", "imageKey": "book/mess"
    },
    "9rJwr": {
        "key": "9rJwr",
        "position": {
            "x": 9,
            "y": 5,
            "z": 1
        },
        "tag": "tree", "imageKey": "book/mess"
    },
    "BZNYO": {
        "key": "BZNYO",
        "position": {
            "x": 5,
            "y": 7,
            "z": 1
        },
        "tag": "tree", "imageKey": "book/mess"
    }
}